export enum QueryParamName {
  Page = "page",
  Sort = "sort",
  Facets = "facets",
  /** @deprecated use `SearchPhrase` instead */
  Keyword = "keyword",
  ItemsPerPage = "size",
  SearchPhrase = "q",
  PreserveUserQuery = "preserveUserQuery",
}
